import React from 'react';
import { Search } from 'lucide-react';

interface FilterProps {
    searchQuery: string;
    setSearchQuery: (query: string) => void;
    activeTab: 'TERMS_CONDITIONS' | 'SERVICE_AGREEMENT';
    selectedVersion: string;
    setSelectedVersion: (version: string) => void;
    selectedDate: string;
    setSelectedDate: (date: string) => void;
}

export const AceptacionesFilter: React.FC<FilterProps> = ({ 
    searchQuery, 
    setSearchQuery, 
    activeTab,
    selectedVersion,
    setSelectedVersion,
    selectedDate,
    setSelectedDate
}) => {
    return (
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 px-4 sm:px-7 py-3 border-b border-gray-200 bg-gray-50/50 shrink-0">
            
            {/* Buscador */}
            <div className="flex items-center w-full sm:w-[300px] gap-2 px-3 py-2 transition-colors border rounded-lg bg-white border-gray-300 focus-within:border-[#4f6df5] focus-within:ring-1 focus-within:ring-[#4f6df5]/20 shadow-sm">
                <Search size={16} className="text-gray-400 shrink-0" />
                <input 
                    type="text" 
                    placeholder="Buscar por usuario, IP o versión..." 
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="w-full text-[13px] bg-transparent border-none outline-none text-gray-900 placeholder:text-gray-400"
                />
            </div>
            
            {/* Filtros rápidos o Fechas */}
            <div className="flex items-center gap-2 w-full sm:w-auto shrink-0">
                {/* Select de versión con su estado */}
                <select 
                    value={selectedVersion}
                    onChange={(e) => setSelectedVersion(e.target.value)}
                    className="flex-1 sm:flex-none px-3 py-2 text-xs bg-white border border-gray-300 rounded-lg text-gray-700 outline-none cursor-pointer shadow-sm focus:border-[#4f6df5]"
                >
                    <option value="">Todas las versiones</option>
                    {activeTab === 'TERMS_CONDITIONS' ? (
                        <>
                            <option value="string">String (Actual)</option>
                            {/* <option value="v2.1.0">v2.1.0</option> */}
                        </>
                    ) : (
                        <>
                            <option value="string">Contrato String (Actual)</option>
                            {/* <option value="v1.0">Contrato v1.0</option> */}
                        </>
                    )}
                </select>
                
                {/* Input de fecha */}
                <input 
                    type="date" 
                    value={selectedDate}
                    onChange={(e) => setSelectedDate(e.target.value)}
                    className="flex-1 sm:flex-none px-3 py-2 text-xs bg-white border border-gray-300 rounded-lg text-gray-700 outline-none cursor-pointer shadow-sm focus:border-[#4f6df5]" 
                />
            </div>
        </div>
    );
};